import React from 'react';
import { Chip } from '@mui/material';
import {
  PowerSettingsNew as PowerIcon,
  Tune as DimIcon,
  Palette as ColorIcon
} from '@mui/icons-material';

const OutputTypeCapabilities = ({ outputType }) => {
  const capabilities = [];
  if (outputType.supportsOnOff) capabilities.push({ label: 'On/Off', icon: <PowerIcon fontSize="small" /> });
  if (outputType.supportsDim) capabilities.push({ label: 'Dim', icon: <DimIcon fontSize="small" /> });
  if (outputType.supportsColor) capabilities.push({ label: 'Color', icon: <ColorIcon fontSize="small" /> });

  return capabilities.map((cap, index) => (
    <Chip
      key={index}
      label={cap.label}
      icon={cap.icon}
      size="small"
      variant="outlined"
      sx={{ mr: 0.5, mb: 0.5 }}
    />
  ));
};

export default OutputTypeCapabilities;
